/**
 * created by lei lei
 * 同步发布的栏目
 */
import React, {Component} from 'react';
import {Modal, Tree, Icon} from 'antd'
import './Concurrently.css'
import {Scrollbars} from "react-custom-scrollbars";
import {getFirstChildKeys} from "../switchBounced/SwitchBounced";
import folder from "./folder.png";
import file from "./file.png"
import siteSize from "./siteIcon.png"

const {TreeNode} = Tree;

export default class Concurrently extends Component {
    constructor(props) {
        super(props);
        this.state = {
            deliveryWay:0,
            checkedKeys:[],
            checkedNodes:[],
            visible:false

        };
    }

    render() {
        const {deliveryWay, visible, checkedKeys} = this.state;
        const {treeData} = this.props;
        let expandedKeys = JSON.parse(JSON.stringify(checkedKeys));
        let defaultExpandedKeys = getFirstChildKeys(treeData, expandedKeys);
        let siteSizeNum = 0;
        return (
            <Modal
                title="同时发布到"
                visible={visible}
                onOk={this.onOk}
                onCancel={()=>{this.setState({visible:false})}}
            >
                <div>
                    {!this.props.hideChoose &&
                    <div className="concurrentlyIssue">
                        <div className={deliveryWay===0 ? "concurrentlyBack" : "concurrentlyButton"}
                             onClick={()=>{
                                 this.setState({
                                     deliveryWay:0
                                 })
                             }}>以正文形式发布
                        </div>
                        <div className={deliveryWay===1 ? "concurrentlyBack" : "concurrentlyButton"}
                             onClick={()=>{
                                 this.setState({
                                     deliveryWay:1
                                 })
                             }}>以链接形式发布
                        </div>
                    </div>}
                    <div className="concurrentlyStyle">
                        <Scrollbars style={{height: 450}}>
                        <Tree
                            showIcon
                            checkable
                            checkedKeys={checkedKeys}
                            onCheck={this.onCheck}
                            // checkStrictly={true}
                            defaultExpandedKeys={defaultExpandedKeys}
                            selectable={false}
                        >
                            {this.renderTreeNodes(treeData,siteSizeNum)}
                        </Tree>
                        </Scrollbars>
                    </div>
                </div>
            </Modal>
        );
    };
    renderTreeNodes = (data,siteSizeNum) => {
        let hideNode = this.props.hideNode || {};
        let hideNodeAttr = this.props.hideNodeAttr || "contentId";
        return (
            data.map(item => {
                if(item[hideNodeAttr] && hideNode[hideNodeAttr] && (item[hideNodeAttr] == hideNode[hideNodeAttr])) {
                    return ""
                }
                if (item.subtree) {
                    return (
                        <TreeNode key={item.key} title={item.title} {...item} dataRef={item}
                                  checkable={false} icon={<img src={siteSizeNum===0?siteSize:folder} style={{marginTop:siteSizeNum==0?"-2px":"0px"}}/>}>
                            {this.renderTreeNodes(item.subtree,siteSize+1)}
                        </TreeNode>
                    );
                }
                let disabled = false;
                if(!this.props.hideChoose){
                    if(this.state.checkedNodes.some(node=>node.key===item.key)) {
                        if(this.state.checkedNodes.find(node=>node.key===item.key).deliveryWay !== this.state.deliveryWay) {
                            disabled = true
                        }
                    }
                }
                return <TreeNode key={item.key} title={item.title} {...item} dataRef={item} disabled={item.bindVsbUser==false?true:false}
                                 checkable={true} disabled={disabled} icon={<img src={file}/>}/>;
            })
        )
    };
    onCheck = (checkedKeys, info) => {
        console.log('info', info);//info.checkedNodes[0].props.dataRef
        // console.log('选中的节点kei', checkedKeys);
        let checkedNodes=[];
        if(info.checkedNodes.length) {
            checkedNodes = info.checkedNodes.map(item=>{
                let dataRef = item.props.dataRef;
                let newObj =this.state.checkedNodes.find(Item=>Item.key===dataRef.key)
                if(newObj ){
                    return newObj
                }
                return dataRef
            })
        }
        if(info.checked) {
            // 如果是选中节点，添加发稿形式
            let checkNodeKey = info.node.props.dataRef.key;
            checkedNodes = checkedNodes.map(item=>{
                if(item.key===checkNodeKey) {
                    item.deliveryWay = this.state.deliveryWay
                }
                return item
            })
        }
        this.setState({checkedNodes,checkedKeys},()=>{
            console.log('checkedNodes        ',checkedNodes)
            console.log('checkedKeys        ',checkedKeys)
        })
    };
    onSetCheckedKeys = (checkedKeys=[],checkedNodes=[]) => {
        this.setState({checkedKeys,checkedNodes})
    };
    onOk = () => {
        let {checkedNodes} = this.state;
        if(typeof this.props.handleOk === 'function') {
            this.props.handleOk(checkedNodes)
        }
        this.hide()
    };

    filterNodes = (checkedNodes, data = this.props.treeData) => {
        return checkedNodes.filter((checkedNode) => {
            // 检查当前节点是否在树中存在匹配
            const foundNode = this.findNodeBykey(data, checkedNode.key);
            return !foundNode; // 如果树中未找到匹配的节点，则保留该节点
        });
    };

    // 辅助函数：根据key在树中查找节点
    findNodeBykey = (data, key) => {
        for (const item of data) {
            if (item.key === key) {
                return item;
            }
            if (item.subColumnTree && item.subColumnTree.length > 0) {
                const foundNode = this.findNodeBykey(item.subColumnTree, key);
                if (foundNode) {
                    return foundNode;
                }
            }
        }
        return null;
    };

    show = () => {
        this.setState({visible:true})
    };
    hide=()=>{
        this.setState({visible:false})
    };
}
